var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 9.999,
    viewBox: "0 0 17.999 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_toggle_button",
    d: "M799.062-8605h-8a5,5,0,0,1-5-5,5.005,5.005,0,0,1,5-5h8a5.006,5.006,0,0,1,5,5A5.005,5.005,0,0,1,799.062-8605Zm-8-9a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0,791.062-8614Z",
    transform: "translate(-786.063 8615)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleWidget);
export default __webpack_public_path__ + "static/media/ToggleWidget.eb3e9aea.svg";
export { ForwardRef as ReactComponent };